// Mock data for Lor95 Boutique

export const products = [
  // FEMRA - VERË
  {
    id: "1",
    name: "Fustan Elegant Mbrëmjeje",
    category: "Fustane",
    gender: "Femra",
    season: "Verë",
    price: 12900,
    image: "https://images.unsplash.com/photo-1767334010488-83cdb8539273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwYm91dGlxdWV8ZW58MHx8fHwxNzcxMjMyMzgzfDA&ixlib=rb-4.1.0&q=85",
    featured: true,
    newArrival: true,
    description: "Fustan sofistikuar mbrëmjeje i përkryer për raste speciale"
  },
  {
    id: "4",
    name: "Fustan Veror i Lehtë",
    category: "Fustane",
    gender: "Femra",
    season: "Verë",
    price: 7900,
    image: "https://images.pexels.com/photos/336372/pexels-photo-336372.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bestSeller: true,
    description: "Fustan i lehtë dhe i rehatshëm për ditët e nxehta të verës"
  },
  {
    id: "7",
    name: "Fustan me Lule Veror",
    category: "Fustane",
    gender: "Femra",
    season: "Verë",
    price: 9900,
    image: "https://images.unsplash.com/photo-1614786269829-d24616faf56d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHx3b21lbiUyMGNsb3RoaW5nfGVufDB8fHx8MTc3MTIzMjM4OHww&ixlib=rb-4.1.0&q=85",
    bestSeller: true,
    newArrival: true,
    description: "Fustan i bukur me lule për verë"
  },
  {
    id: "11",
    name: "Bluzë e Lehtë Veror",
    category: "Veshje e Përditshme",
    gender: "Femra",
    season: "Verë",
    price: 5900,
    image: "https://images.unsplash.com/photo-1590330297626-d7aff25a0431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGNsb3RoaW5nfGVufDB8fHx8MTc3MTIzMjM4OHww&ixlib=rb-4.1.0&q=85",
    description: "Bluzë e lehtë për ditë të nxehta"
  },

  // FEMRA - DIMËR
  {
    id: "2",
    name: "Pallto Klasike Dimërore",
    category: "Veshje e Përditshme",
    gender: "Femra",
    season: "Dimër",
    price: 15900,
    image: "https://images.unsplash.com/photo-1573879500655-98f2012dd1db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxmYXNoaW9uJTIwYm91dGlxdWV8ZW58MHx8fHwxNzcxMjMyMzgzfDA&ixlib=rb-4.1.0&q=85",
    featured: true,
    bestSeller: true,
    description: "Pallto e ngrohtë klasike për dimër"
  },
  {
    id: "5",
    name: "Set Xhakete Dimërore",
    category: "Veshje e Përditshme",
    gender: "Femra",
    season: "Dimër",
    price: 13900,
    image: "https://images.unsplash.com/photo-1761370571873-5d869310d731?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxmYXNoaW9uJTIwYm91dGlxdWV8ZW58MHx8fHwxNzcxMjMyMzgzfDA&ixlib=rb-4.1.0&q=85",
    newArrival: true,
    description: "Set elegante xhakete për dimër"
  },
  {
    id: "8",
    name: "Triko i Ngrohtë Dimëror",
    category: "Veshje e Përditshme",
    gender: "Femra",
    season: "Dimër",
    price: 6900,
    image: "https://images.unsplash.com/photo-1590330297626-d7aff25a0431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGNsb3RoaW5nfGVufDB8fHx8MTc3MTIzMjM4OHww&ixlib=rb-4.1.0&q=85",
    featured: true,
    description: "Triko i ngrohtë për dimër"
  },
  {
    id: "10",
    name: "Veshje Profesionale Dimërore",
    category: "Veshje e Përditshme",
    gender: "Femra",
    season: "Dimër",
    price: 14900,
    image: "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx3b21lbiUyMGNsb3RoaW5nfGVufDB8fHx8MTc3MTIzMjM4OHww&ixlib=rb-4.1.0&q=85",
    bestSeller: true,
    description: "Veshje profesionale për dimër"
  },

  // MESHKUJ - VERË
  {
    id: "12",
    name: "Këmishë e Lehtë Veror",
    category: "Këmisha",
    gender: "Meshkuj",
    season: "Verë",
    price: 6900,
    image: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    newArrival: true,
    description: "Këmishë e lehtë për verë"
  },
  {
    id: "13",
    name: "T-Shirt Casual Veror",
    category: "Veshje e Përditshme",
    gender: "Meshkuj",
    season: "Verë",
    price: 3900,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    bestSeller: true,
    description: "T-shirt i rehatshëm për verë"
  },
  {
    id: "14",
    name: "Pantallona të Shkurtra Veror",
    category: "Pantallona",
    gender: "Meshkuj",
    season: "Verë",
    price: 5900,
    image: "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    featured: true,
    description: "Pantallona të shkurtra për verë"
  },
  {
    id: "15",
    name: "Polo Elegant Veror",
    category: "Këmisha",
    gender: "Meshkuj",
    season: "Verë",
    price: 7900,
    image: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    newArrival: true,
    description: "Polo elegant për verë"
  },

  // MESHKUJ - DIMËR
  {
    id: "16",
    name: "Xhaketë e Ngrohtë Dimërore",
    category: "Xhaketa",
    gender: "Meshkuj",
    season: "Dimër",
    price: 18900,
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    featured: true,
    bestSeller: true,
    description: "Xhaketë e ngrohtë për dimër"
  },
  {
    id: "17",
    name: "Pullover Klasik Dimëror",
    category: "Veshje e Përditshme",
    gender: "Meshkuj",
    season: "Dimër",
    price: 8900,
    image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    bestSeller: true,
    description: "Pullover i ngrohtë klasik"
  },
  {
    id: "18",
    name: "Pallto Elegante Dimërore",
    category: "Xhaketa",
    gender: "Meshkuj",
    season: "Dimër",
    price: 22900,
    image: "https://images.unsplash.com/photo-1539533018447-63fcce2678e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    newArrival: true,
    featured: true,
    description: "Pallto elegante për dimër"
  },
  {
    id: "19",
    name: "Pantallona Formale Dimërore",
    category: "Pantallona",
    gender: "Meshkuj",
    season: "Dimër",
    price: 9900,
    image: "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    description: "Pantallona formale për dimër"
  },

  // AKSESORË
  {
    id: "3",
    name: "Çanta Dizajnere",
    category: "Aksesorë",
    gender: "Femra",
    season: "Të gjitha",
    price: 8900,
    image: "https://images.unsplash.com/photo-1570857502809-08184874388e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwYm91dGlxdWV8ZW58MHx8fHwxNzcxMjMyMzgzfDA&ixlib=rb-4.1.0&q=85",
    featured: true,
    newArrival: true,
    description: "Çanta lëkure premium"
  },
  {
    id: "6",
    name: "Aksesorë të Veçantë",
    category: "Aksesorë",
    gender: "Femra",
    season: "Të gjitha",
    price: 4900,
    image: "https://images.pexels.com/photos/31763620/pexels-photo-31763620.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    featured: true,
    description: "Aksesorë elegantë"
  },
  {
    id: "9",
    name: "Këpucë Dizajnere",
    category: "Aksesorë",
    gender: "Femra",
    season: "Të gjitha",
    price: 11900,
    image: "https://images.unsplash.com/photo-1532453288672-3a27e9be9efd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHx3b21lbiUyMGNsb3RoaW5nfGVufDB8fHx8MTc3MTIzMjM4OHww&ixlib=rb-4.1.0&q=85",
    newArrival: true,
    bestSeller: true,
    description: "Këpucë premium"
  },
  {
    id: "20",
    name: "Rrip Lëkure Klasik",
    category: "Aksesorë",
    gender: "Meshkuj",
    season: "Të gjitha",
    price: 4900,
    image: "https://images.unsplash.com/photo-1624222247344-550fb60583bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0fDB8MHx8fHx8fHx8fDE3NzEyMzI0MDB8&ixlib=rb-4.1.0&q=85",
    description: "Rrip lëkure klasik"
  }
];


// ============================================================
// HERO IMAGES
// ============================================================

export const heroImages = [
  {
    url: "https://images.unsplash.com/photo-1666635241732-10ddcf3801dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZmFzaGlvbiUyMG1vZGVsfGVufDB8fHx8MTc3MTIzMjM1MXww&ixlib=rb-4.1.0&q=85",
    alt: "Elegant Fashion Model"
  },
  {
    url: "https://images.unsplash.com/photo-1673378700788-574834c04f64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBib3V0aXF1ZXxlbnwwfHx8fDE3NzEyMzIzNTZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Elegant Lifestyle"
  }
];


// ============================================================
// BUSINESS INFO
// ============================================================

export const businessInfo = {
  name: "Lor95 Boutique",
  address: "Rruga Desaret, Berat 5001, Albania",
  locationCode: "PX27+PR, Berat, Albania",
  phone: "+355 69 352 0111",
  instagram: "https://www.instagram.com/lor_95_boutique/",
  hours: "Open daily – Closes at 9:00 PM",
  logo: "/lor95.png",
  storefrontImage: "/images/storefront.jpg",
  clothingRacksImage: "/images/clothing-racks.jpg"
};


// ============================================================
// IMAGE URL HELPER
// ============================================================

export const imgUrl = (image) => {
  if (!image) {
    return "";
  }

  return image.startsWith("/")
    ? `${process.env.REACT_APP_BACKEND_URL}${image}`
    : image;
};


// ============================================================
// CART - LOCAL STORAGE
// ============================================================

export const getCart = () => {
  try {
    const cart = localStorage.getItem("lor95_cart");

    return cart
      ? JSON.parse(cart)
      : [];
  } catch (error) {
    console.error("Gabim gjatë leximit të shportës:", error);

    return [];
  }
};


export const saveCart = (cart) => {
  localStorage.setItem(
    "lor95_cart",
    JSON.stringify(cart)
  );
};


// ============================================================
// ADD TO CART
// ============================================================

export const addToCart = (
  product,
  quantity = 1,
  size = null,
  color = null
) => {

  const cart = getCart();

  const normalizedSize =
    size || "";

  const normalizedColor =
    color || "";

  /*
   * Çdo kombinim:
   *
   * produkt + ngjyrë + masë
   *
   * konsiderohet item më vete.
   *
   * Shembull:
   *
   * abc123__E zezë__L
   * abc123__E bardhë__L
   * abc123__E zezë__M
   */

  const cartId = [
    product.id,
    normalizedColor,
    normalizedSize
  ].join("__");


  const existingItem =
    cart.find(
      item =>
        (item.cartId || item.id)
        === cartId
    );


  // ==========================================================
  // FIND REAL STOCK OF SELECTED VARIANT
  // ==========================================================

  let variantStock =
    Number(
      product.stock
      ??
      0
    );


  if (
    Array.isArray(product.variants)
    &&
    product.variants.length > 0
  ) {

    const selectedVariant =
      product.variants.find(
        variant =>
          (
            variant.color
            || ""
          ).toLowerCase()
          ===
          normalizedColor.toLowerCase()

          &&

          (
            variant.size
            || ""
          ).toLowerCase()
          ===
          normalizedSize.toLowerCase()
      );


    if (selectedVariant) {

      variantStock =
        Number(
          selectedVariant.stock
          ||
          0
        );
    }
  }


  // ==========================================================
  // EFFECTIVE PRICE
  // ==========================================================

  const hasSale =
    product.salePrice != null
    &&
    Number(product.salePrice) > 0
    &&
    Number(product.salePrice) < Number(product.price);

  const effectivePrice =
    hasSale
      ? Number(product.salePrice)
      : Number(product.price);

  const originalPrice =
    Number(product.price);


  // ==========================================================
  // EXISTING ITEM
  // ==========================================================

  if (existingItem) {

    const newQuantity =
      existingItem.quantity
      +
      quantity;


    if (
      variantStock > 0
      &&
      newQuantity > variantStock
    ) {

      existingItem.quantity =
        variantStock;

    } else {

      existingItem.quantity =
        newQuantity;
    }


    existingItem.variantStock =
      variantStock;

    existingItem.color =
      normalizedColor;

    existingItem.size =
      normalizedSize;

    existingItem.price =
      effectivePrice;

    existingItem.originalPrice =
      originalPrice;

    existingItem.salePrice =
      hasSale
        ? effectivePrice
        : null;

  } else {

    // ========================================================
    // NEW ITEM
    // ========================================================

    cart.push({
      ...product,

      price:
        effectivePrice,

      originalPrice:
        originalPrice,

      salePrice:
        hasSale
          ? effectivePrice
          : null,

      cartId,

      size:
        normalizedSize,

      color:
        normalizedColor,

      variantStock,

      quantity
    });
  }


  saveCart(cart);

  return cart;
};


// ============================================================
// REMOVE FROM CART
// ============================================================

export const removeFromCart = (
  cartId
) => {

  const cart =
    getCart();


  const updatedCart =
    cart.filter(
      item =>
        (item.cartId || item.id)
        !== cartId
    );


  saveCart(
    updatedCart
  );


  return updatedCart;
};


// ============================================================
// UPDATE CART QUANTITY
// ============================================================

export const updateCartQuantity = (
  cartId,
  quantity
) => {

  const cart =
    getCart();


  const item =
    cart.find(
      item =>
        (item.cartId || item.id)
        === cartId
    );


  if (item) {

    const maxStock =
      Number(
        item.variantStock
        ??
        item.stock
        ??
        999
      );


    if (
      maxStock > 0
      &&
      quantity > maxStock
    ) {

      item.quantity =
        maxStock;

    } else {

      item.quantity =
        Math.max(
          1,
          quantity
        );
    }


    saveCart(
      cart
    );
  }


  return cart;
};


// ============================================================
// CLEAR CART
// ============================================================

export const clearCart = () => {

  localStorage.removeItem(
    "lor95_cart"
  );

  return [];
};